import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from "vue";
import { GoogleMap } from "vue3-google-map";

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexGoogle',
  setup(__props) {

const apiKey = import.meta.env.GOOGLE_MAPS_API_KEY as string;
let Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"));
const Markers = defineAsyncComponent(
  () => import("@/components/theme/maps/MarkersMap.vue")
);
const DraggableMarker = defineAsyncComponent(
  () => import("@/components/theme/maps/DraggableMarker.vue")
);
const GooglePolyline = defineAsyncComponent(
  () => import("@/components/theme/maps/GooglePolyline.vue")
);
const TrianglePolygon = defineAsyncComponent(
  () => import("@/components/theme/maps/TrianglePolygon.vue")
);

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Map",
      mains: "Google Map",
      title: "Google Map"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card3), {
          colClass: "col-sm-6",
          cardhaderClass: "card-no-border pb-0",
          pre: "true",
          preClass: "mt-1 mb-0",
          title: "Map at a specified location",
          headerTitle: "true",
          desc: "Display a map at a specified location and zoom level."
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GoogleMap), {
              "api-key": _unref(apiKey),
              center: { lat: 20.5937, lng: 78.9629 },
              zoom: 12,
              style: {"width":"auto","height":"500px"}
            }, null, 8, ["api-key"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          title: "Multi-language support",
          pre: "true",
          preClass: "mt-1 mb-0",
          headerTitle: "true",
          desc: "Display a map with labels in a foreign language"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GoogleMap), {
              "api-key": _unref(apiKey),
              center: { lat: 20.5937, lng: 78.9629 },
              zoom: 6,
              style: {"width":"auto","height":"500px"},
              options: {
            region: 'VI',
            language: 'vi',
          }
            }, null, 8, ["api-key"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          title: "Marker on the Map",
          pre: "true",
          preClass: "mt-1 mb-0",
          headerTitle: "true",
          desc: "Display a map highlighting points of interest"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Markers))
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          title: "Draggable Marker",
          pre: "true",
          preClass: "mt-1 mb-0",
          headerTitle: "true",
          desc: "Display a map highlighting points of interest"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DraggableMarker))
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          title: "Polyline on the Map",
          pre: "true",
          preClass: "mt-1 mb-0",
          headerTitle: "true",
          desc: "Display a map with a line showing a known route"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GooglePolyline))
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          title: "Polygon on the Map",
          pre: "true",
          preClass: "mt-1 mb-0",
          headerTitle: "true",
          desc: "Display a map highlighting a region or area"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TrianglePolygon))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})